/**
 * Do not edit directly, use `yarn generate:icons`
 */

import React from 'react';
import {Base} from '../../../Internal/Base/';

const pathStrings = {
  16: [
    'M10.667 1.5A3.833 3.833 0 0114.5 5.333v5.334a3.833 3.833 0 01-3.833 3.833H5.333A3.833 3.833 0 011.5 10.667V5.333A3.833 3.833 0 015.333 1.5h5.334zm-5.334 1A2.833 2.833 0 002.5 5.333v5.334A2.833 2.833 0 005.333 13.5h5.334a2.833 2.833 0 002.833-2.833V5.333A2.833 2.833 0 0010.667 2.5H5.333zm3.934 1a.9.9 0 01.9.9v1.433H11.6a.9.9 0 01.9.9v2.534a.9.9 0 01-.9.9h-1.433V11.6a.9.9 0 01-.9.9H6.733a.9.9 0 01-.9-.9v-1.433H4.4a.9.9 0 01-.9-.9V6.733a.9.9 0 01.9-.9h1.433V4.4a.9.9 0 01.9-.9h2.534zM6.833 5.934a.9.9 0 01-.9.899H4.5v2.334h1.434a.9.9 0 01.899.9V11.5h2.334v-1.434a.9.9 0 01.9-.899H11.5V6.833h-1.434a.9.9 0 01-.899-.9V4.5H6.833v1.434z',
  ],

  24: [
    'M16 2.25A5.75 5.75 0 0121.75 8v8A5.75 5.75 0 0116 21.75H8A5.75 5.75 0 012.25 16V8A5.75 5.75 0 018 2.25h8zm-8 1.5A4.25 4.25 0 003.75 8v8A4.25 4.25 0 008 20.25h8A4.25 4.25 0 0020.25 16V8A4.25 4.25 0 0016 3.75H8zm5.9 1.5c.746 0 1.35.604 1.35 1.35v2.15h2.15c.746 0 1.35.604 1.35 1.35v3.8a1.35 1.35 0 01-1.35 1.35h-2.15v2.15a1.35 1.35 0 01-1.35 1.35h-3.8a1.35 1.35 0 01-1.35-1.35v-2.15H6.6a1.35 1.35 0 01-1.35-1.35v-3.8c0-.746.604-1.35 1.35-1.35h2.15V6.6c0-.746.604-1.35 1.35-1.35h3.8zM10.25 8.9a1.35 1.35 0 01-1.35 1.35H6.75v3.5H8.9c.746 0 1.35.604 1.35 1.35v2.15h3.5V15.1c0-.746.604-1.35 1.35-1.35h2.15v-3.5H15.1a1.35 1.35 0 01-1.35-1.35V6.75h-3.5V8.9z',
  ],
};

type Props = {size: keyof typeof pathStrings} & Omit<
  React.SVGAttributes<HTMLOrSVGElement>,
  'width' | 'height' | 'viewBox'
>;

export const IconMedicalDental = ({
  size,
  className,
  ...rest
}: Props): React.ReactElement<React.ReactSVGElement> => {
  const paths = pathStrings[size].map((d: string, i: number) => (
    <path key={String(i)} d={d} fillRule="evenodd" />
  ));

  return (
    <Base
      as="svg"
      height={size}
      width={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      // Because viewPort(height + width) and viewBox might not have the same ratio
      // `preserveAspectRatio` indicates wether we should force a uniform scaling.
      // Therefore, `xMidYMid` centers the viewBox region within the viewPort region,
      // and `meet` scales the graphic until it meets the height and width of our viewPort.
      // More details here, https://www.digitalocean.com/community/tutorials/svg-preserve-aspect-ratio
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      {...rest}
    >
      {paths}
    </Base>
  );
};

IconMedicalDental.displayName = 'IconMedicalDental';
